import { render, staticRenderFns } from "./categories_splash.vue?vue&type=template&id=69c92e1b"
import script from "./categories_splash.vue?vue&type=script&lang=js"
export * from "./categories_splash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports